<template>
  <div id="app">
    <GameBoardView />
  </div>
</template>

<script>
import GameBoardView from './components/GameBoardView.vue'

export default {
  name: 'App',
  components: {
    GameBoardView
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
